import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { NAV } from "./content";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-bone/80 backdrop-blur-xl border-b border-surface-alt" : "bg-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex h-20 items-center justify-between">
          <a href="#top" className="flex items-baseline gap-2 group" data-testid="logo-link">
            <span className="font-display text-2xl tracking-tight text-forest">Wellknowe</span>
            <span className="overline text-ink-soft pb-0.5">Ltd</span>
          </a>

          <nav className="hidden md:flex items-center gap-9">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                className="font-mono-label text-[0.78rem] uppercase tracking-[0.14em] text-ink-soft hover:text-forest transition-colors duration-200"
                data-testid={`nav-${n.href.replace("#", "")}`}
              >
                {n.label}
              </a>
            ))}
          </nav>

          <a
            href="#contact"
            className="hidden md:inline-flex items-center gap-2 rounded-full bg-forest px-6 py-3 text-sm font-medium text-bone hover:bg-forest-accent transition-colors duration-200 group"
            data-testid="header-cta"
          >
            Book cover
            <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>

          <button
            className="md:hidden text-forest"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="md:hidden overflow-hidden bg-bone border-b border-surface-alt"
            data-testid="mobile-menu"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {NAV.map((n) => (
                <a
                  key={n.href}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  className="font-display text-2xl text-forest"
                  data-testid={`mobile-nav-${n.href.replace("#", "")}`}
                >
                  {n.label}
                </a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
